---
import type { UserOwnInfo } from "@ka-astro/auth";
import type { UserProfile } from "@ka-astro/header/components/HeaderBottom/userProfile.d.ts";

export interface Props {
  user: UserOwnInfo | null | undefined;
  userProfile: UserProfile | null | undefined;
}

const { user, userProfile } = Astro.props;

const sharedData = {
  user: user || {},
  userProfile: userProfile || {},
};

const sharedDataString = JSON.stringify(sharedData);
---

<script
  id="astroSharedData"
  type="application/json"
  set:html={sharedDataString}
/>

<script>
  import {
    userStore,
    userProfileStore,
    isUserLoggedInStore,
  } from "@ka-astro/shared-data";

  const astroSharedData = JSON.parse(
    document?.getElementById("astroSharedData")?.textContent || "{}",
  );

  userStore.set(astroSharedData.user);
  userProfileStore.set(astroSharedData.userProfile);
  isUserLoggedInStore.set(!!astroSharedData.user);
</script>
